import Repository from "../Repository";

const resource = "/seats";
export default {
    get() {
        return Repository.get(`${resource}`);
    },
    getDistinctSSP() {
        return Repository.get(`${resource}/ssp`);
    },
    getDistinctDSP() {
        return Repository.get(`${resource}/dsp`);
    },
    getSeat(id) {
        return Repository.get(`${resource}/${id}`);
    },
    create(json) {
        return Repository.post(`${resource}`, json);
    },
    update(id, json) {
        return Repository.put(`${resource}/${id}`, json);
    },
    delete(id) {
        return Repository.delete(`${resource}/${id}`);
    }
}